export default [
  {
    path: '/report/daily/mahar_net_bill_mgmt',
    name: 'DailyMaharNETBillMgmt',
    component: () =>
      import(
        /* webpackChunkName: "network_report" */ '@/projects/operation/views/Billing/NetWork/DailyMaharNETBillMgmt.vue'
      )
  }
]
